export default function pushConversationalInteractionEvent(interactionType, additionalData = {}) {
    let dataLayer = {
        event: 'conversational_interaction',
        interaction_type: interactionType,
    };

    Object.keys(additionalData).forEach(key => {
        if (additionalData[key] !== null && additionalData[key] !== undefined) {
            dataLayer[key] = additionalData[key];
        }
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayer);
}
